<div *ngIf="recording$ | async as recording">

<h1>{{recording.name}}</h1>
<i>{{recording.recordingDate | date:'medium'}}</i>
<br /><br />

<pre>{{recording | json}}</pre>

</div>
